import {
    NestedField,
} from 'app/types/form.types'
import {
    Timezone,
} from 'app/enums/label.enums'
import {
    LocationFormFields,
} from '../LocationForm.types'

const getAddressFieldDetails = ({
    country,
    categoriesValue,
    timeZones,
    allowedCategories,
    setAutocomplete,
    currentPlaceId,
    value,
    timeZone,
    isGoogleMapsServiceLoaded,
    isAddressType,
    getAllowedValues,
    isProspect,
    isShippingLocation,
    isCompanyDisabled,
}): NestedField<LocationFormFields>[] => {
    const addressFields: NestedField<LocationFormFields>[] = [
        isGoogleMapsServiceLoaded
            ? {
                name: 'addressLine1',
                componentName: 'GoogleAddress',
                required: !isProspect,
                setAutocomplete,
                currentPlaceId,
                formData: value,
                isGoogleMapsServiceLoaded,
                labelKey: 'ADDRESS_LINE_1',
            } : {
                name: 'addressLine1',
                required: true,
                componentName: 'InputSingleline',
                labelKey: 'ADDRESS_LINE_1',
            },
        {
            name: 'addressLine2',
            componentName: 'InputSingleline',
            labelKey: 'ADDRESS_LINE_2',
        },
        {
            name: 'addressLine3',
            componentName: 'InputSingleline',
            labelKey: 'ADDRESS_LINE_3',
        },
    ]
    const categoriesFields: NestedField<LocationFormFields> = {
        name: 'addressCategory',
        componentName: 'MultiEnumSelector',
        title: 'Categories',
        value: categoriesValue,
        allowedValues: allowedCategories,
        required: !!isAddressType,
        labelKey: 'CATEGORY',
    }

    const companyFields: NestedField<LocationFormFields> = {
        name: 'company',
        componentName: 'CompanyObjectSelector',
        required: !isProspect,
        disabled: isCompanyDisabled,
        labelKey: 'COMPANY',
    }
    const isNotProspectfields: NestedField<LocationFormFields>[] = [
        {
            name: 'isMainAddress',
            componentName: 'Switch',
            labelKey: 'IS_MAIN_ADDRESS',
        },
        {
            name: 'isApprovedSubContractor',
            componentName: 'Switch',
            labelKey: 'APPROVED_SUB_CONTRACTOR',
        },
    ]
    const addressFields2: NestedField<LocationFormFields>[] = [
        {
            name: 'country',
            componentName: 'CountryDataSelector',
            required: true,
            labelKey: 'COUNTRY',
        },
        {
            name: 'zip',
            componentName: 'ZipCodeInput',
            required: true,
            country,
            labelKey: 'ZIP_CODE',
        },
        {
            name: 'state',
            componentName: 'StateSelector',
            country: country?.id,
            labelKey: 'STATE',
        },
        {
            componentName: 'CitySuggestions',
            required: !isProspect,
            name: 'city',
            timeZones,
            labelKey: 'CITY',
        },
        {
            name: 'timeZone',
            componentName: 'EnumSelector',
            allowedValues: getAllowedValues(Timezone),
            required: !isProspect && isShippingLocation,
            value: timeZone,
            labelKey: 'TIME_ZONE',
        },
        {
            name: 'remarks',
            componentName: 'InputSingleline',
            labelKey: 'REMARKS',
        },
    ]

    return isProspect
        ? [
            ...addressFields,
            companyFields,
            ...addressFields2,
        ]
        : [
            ...addressFields,
            categoriesFields,
            companyFields,
            ...isNotProspectfields,
            ...addressFields2,
        ]
}

export default getAddressFieldDetails
